'use client'
import Link from 'next/link'

// import { usePathname } from '@/i18n/navigation'

import { APPLY_LINK_SOURCE } from '@/config/constants'
import { DocType } from '@/types/Content.types'

import ApplyLink from '@/components/molecules/ApplyLink'

import Flex from '@/components/atoms/Flex'
import Button from '@/components/atoms/Button'
import Icon from '@/components/atoms/Icon'
import { ButtonLabel } from '@/components/atoms/Typography'

import styles from './HeroActions.module.scss'

const HeroActions = ({ docs }: { docs: DocType[] }) => {
  // TODO: general wrong implementation, fix this
  // const pathname = usePathname()
  const href =
    'https://www.naba.it/en/ug-competition-application-form-july-25?utm_source=competition'
  return (
    <Flex
      className={styles.actions}
      gap='1rem'
    >
      <Flex
        gap='.5rem'
        wrap
      >
        <ApplyLink
          source={APPLY_LINK_SOURCE.competition}
          className={styles.button}
          autoWidth
          label='Apply Now'
          href={href}
        />
        {docs.map((doc) => (
          <Button
            className={styles.button}
            autoWidth
            as={Link}
            key={doc.label}
            // variant='secondary'
            theme='dark'
            Icon={() => <Icon iconName='FilePDF' />}
            {...doc}
          >
            <ButtonLabel
              size='md'
              weight='semi-bold'
            >
              {doc.label}
            </ButtonLabel>
          </Button>
        ))}
      </Flex>

      {/* TODO: add share button */}
    </Flex>
  )
}

export default HeroActions
